import React, { useEffect, useState } from "react";
import apiClient from "lib/api-client";
import SalesTables from "./SalesTables";

const SaleTray = ({ styleNumber }) => {
  const [totalSales, setTotalSales] = useState([]);
  const [count, setCount] = useState();
  const [loading, setLoading] = useState(false);

  const fetchTotalSales = async () => {
    setLoading(true);
    try {
      const response = await apiClient.post(`/api/v1/styles/salesBagTest`, {
        styleNumber: styleNumber || "BA-00008",
      });

      if (response?.data) {
        setTotalSales(Object.entries(response?.data?.data).map(([key, value]) => [key, value]) || []);
        setCount(response?.data?.salesCount || 0);
      }
    } catch (error) {
      console.error("Error fetching sales data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTotalSales();
  }, [styleNumber]);

  if (loading) return <div>Loading...</div>;

  return (
    <div style={{ maxHeight: "60vh", overflowY: "auto", scrollbarWidth: "none", msOverflowStyle: "none" }}>
      <SalesTables salesData={totalSales} count={count} />
    </div>
  );
};

export default SaleTray;
